<div [formGroup]="form" class="informate_select_wrapper">
    <mat-label class="font-style" [ngbTooltip]="jointConfiguration_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Joint Configuration -->
        {{ 'ENGINEERED_JOINT_PAGE.LABELS.CALC_INPUT.JOINT_CONFIGURATION' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #jointConfiguration_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.JOINT_CONFIGURATION' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <mat-select formControlName="jointConfiguration" name="jointConfiguration" class="input-select" [class.spinner]="loading">
        <mat-option class="option-list" *ngFor="let x of optionList" [value]="x.jointConfigurationIndex">{{ x.jointConfigurationName }} </mat-option>
    </mat-select>
</div>
